import Vue from "vue";
export default {
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_IS_COMPARING(state, payload) {
    state.isComparing = payload;
  },
  SET_SELECTED_DATE(state, payload) {
    state.selectedDate = payload;
  },
  SET_SELECTED_FACILITY(state, payload) {
    state.selectedFacility = payload;
  },
  SET_COMPARISON_DATE(state, payload) {
    state.comparisonDate = payload;
  },
  SET_SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload;
  },
  SET_IS_AUTO_CATEGORIZED(state, payload) {
    state.isAutoCategorized = payload;
  },
  SET_SELECTED_APPS(state, payload) {
    state.selectedApps = payload;
  }
};
